<div class="container">
    <mat-card>
      <table class="members-table" >
        <tbody>
          <tr>
            <th>ID</th>
            <th>User ID</th>
            <th>Name</th>
            <th>Role</th>
          </tr>
          <tr *ngFor="let member of memberData">
            <td>{{member?.id}}</td>
            <td><a (click)="navigateToUserInfo(member?.user_id)">{{member?.user_id}}</a></td>
            <td>{{capitalizeFirstLetter(member?.name)}}</td>
            <td [title]="getRoleTooltip(member?.role)">{{ getDisplayRole(member?.role) }}</td>
          </tr>
        </tbody>
      </table>
    </mat-card>
  </div>
  